import { UpdatesFeedCategory } from '~/pages/Authenticated/Dashboard/components/UpdatesFeed/types';

export const UPDATES_FEED_TAB_ELEMENTS = [
  { label: 'All updates', value: UpdatesFeedCategory.AllUpdates },
  { label: 'Activity Logs', value: UpdatesFeedCategory.ActivityLogs },
  { label: 'Applications', value: UpdatesFeedCategory.Applications },
  { label: 'New Activities', value: UpdatesFeedCategory.NewActivities },
  { label: 'New members', value: UpdatesFeedCategory.NewMembers },
];
